module.exports = __webpack_public_path__ + "img/image-4.703cf65b.jpg";